module.exports = __webpack_public_path__ + "img/2.0714b360.png";